<footer
  [ngClass]="{
    'site-footer-sgroup': appContext?.siteName == 'ShamalGroup',
    'site-footer-hostmtrips':
      appContext?.siteName == 'HostMyTrips' ||
      appContext.siteName == 'OneStopParking',
    'site-footer-wrapper':
      appContext?.siteName !== 'ShamalGroup' &&
      appContext?.siteName !== 'HostMyTrips' &&
      appContext.siteName !== 'OneStopParking'
  }"
  *ngIf="appContext.siteName !== 'Sharecare'"
>
  <div
    class="container footer-div"
    *ngIf="
      appContext.siteName != 'ShamalGroup' &&
      appContext.siteName != 'HostMyTrips' &&
      appContext.siteName != 'OneStopParking' &&
      appContext.siteName != 'OneStopParking' &&
      appContext.siteName != 'Gocaribbea' &&
      appContext.siteName !== 'ReservationsExpert'
    "
  >
    <div class="row">
      <div class="col">
        <div class="row commom-footermenu-div">
          <div>
            <ng-container>
              <a
                class="media"
                *ngIf="displaySetting?.footer?.facebookHref !== undefined"
                href="{{ displaySetting?.footer?.facebookHref }}"
                target="_blank"
              >
                <i class="fa fa-facebook-f"></i>
              </a>
              <a
                class="media"
                *ngIf="displaySetting?.footer?.instagramHref !== undefined"
                href="{{ displaySetting?.footer?.instagramHref }}"
                target="_blank"
              >
                <i class="fa fa-instagram"></i>
              </a>
              <a
                class="media"
                *ngIf="displaySetting?.footer?.linkedInHref !== undefined"
                href="{{ displaySetting?.footer?.linkedInHref }}"
                target="_blank"
              >
                <i class="fa fa-linkedin"></i>
              </a>
              <a
                class="media"
                *ngIf="displaySetting?.footer?.twitterHref !== undefined"
                href="{{ displaySetting?.footer?.twitterHref }}"
                target="_blank"
              >
                <i class="fa fa-twitter"></i>
              </a>
              <a
                class="media"
                *ngIf="displaySetting?.footer?.youtubeHref !== undefined"
                href="{{ displaySetting?.footer?.youtubeHref }}"
                target="_blank"
              >
                <i class="fa fa-youtube" aria-hidden="true"></i>
              </a>
              <a
                class="media tiktok-align"
                *ngIf="displaySetting?.footer?.tiktokHref !== undefined"
                href="{{ displaySetting?.footer?.tiktokHref }}"
                target="_blank"
              >
                <img
                  class="img-align"
                  src="./assets/images/tiktok.svg"
                  alt=""
                />
              </a>
            </ng-container>
          </div>
        </div>
        <div class="row commom-footermenu-div">
          <div>
            <ng-container>
              <li
                class="nav-item"
                style="list-style: none"
                *ngFor="let link of footermenus; let index = index"
              >
                <a
                  href="{{ link.href }}"
                  target="_blank"
                  [ngClass]="
                    appContext.siteName == 'Joy'
                      ? 'joylife-footermenu'
                      : appContext.siteName == 'DemoPortal'
                      ? 'joylife-footermenu'
                      : 'footermenu'
                  "
                  class="nav-link navanchor"
                  >{{ link.text }}
                  <span *ngIf="index < footermenus.length - 1"
                    >&nbsp; | &nbsp;</span
                  ></a
                >
              </li>
            </ng-container>
          </div>
        </div>
        <div class="row commom-footermenu-div">
          <div>
            <span
              [ngClass]="
                appContext.siteName == 'Joy'
                  ? 'joylife-footermenu'
                  : appContext.siteName == 'DemoPortal'
                  ? 'joylife-footermenu'
                  : 'copy-right'
              "
              >{{ displaySetting?.footer?.copyright }}</span
            >
          </div>
        </div>
        <div class="corelationId">
          <span
            [ngStyle]="
              appContext.siteName == 'Chekins'
                ? { color: 'var(--primary)' }
                : { color: 'var(--footer-background)' }
            "
            >{{ appContext.searchKey }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <div
    class="container sg-footer-main-div"
    *ngIf="appContext.siteName == 'ShamalGroup'"
  >
    <div class="main-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">our company</div>
              <div class="context">
                <ul>
                  <li *ngFor="let footer of shamalGroupFooterLinks.company">
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">media</div>
              <div class="context">
                <ul *ngFor="let footer of shamalGroupFooterLinks.media">
                  <li>
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">blog</div>
              <div class="context">
                <ul *ngFor="let footer of shamalGroupFooterLinks.blog">
                  <li>
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">Connect with us</div>
              <div class="context">
                <div class="contact">
                  <div class="sub">
                    <div
                      *ngFor="
                        let socialMedia of shamalGroupFooterLinks.socialMedia
                      "
                    >
                      <a
                        *ngIf="socialMedia.link"
                        class="media"
                        href="{{ socialMedia.link }}"
                        target="_blank"
                      >
                        <img
                          style="width: 35px"
                          src="{{ socialMedia.icon }}"
                          alt="Social Media Icon"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sg-copy-right" *ngIf="appContext.siteName == 'ShamalGroup'">
    <div>
      <p class="sg-copy">{{ displaySetting?.footer?.copyright }}</p>
      <p class="sg-cid">{{ appContext.searchKey }}</p>
    </div>
  </div>

  <div *ngIf="appContext.siteName == 'Gocaribbea'">
    <footer class="footer goCarebbia-footer">
      <div class="footer-container">
        <div class="footer-column">
          <h3>About Go Caribbea</h3>
          <p>
            Welcome to GoCaribbea.com, your go-to destination for the best rates
            on hotel and all-inclusive packages in the Caribbean. We specialize
            in offering unbeatable deals on hotel and flight packages, ensuring
            a hassle-free and unforgettable vacation. Explore the pristine
            beaches, vibrant culture, and stunning landscapes of the Caribbean
            with our exclusive offers tailored just for you.
          </p>
        </div>

        <div class="footer-column">
          <h3>Useful Links</h3>
          <ul *ngFor="let flink of footermenus">
            <li>
              <a href="{{ flink.href }}" target="_blank">{{ flink.text }}</a>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h3>Contact Us</h3>
          <p>
            <mat-icon> phone</mat-icon
            ><a [href]="'tel:' + displaySetting?.phone">{{
              displaySetting?.phone
            }}</a>
          </p>
          <p class="link"><mat-icon> chat</mat-icon> Chat With Agent</p>
          <p>
            <mat-icon> mail</mat-icon
            ><a [href]="'mailto:' + displaySetting?.email">{{
              displaySetting?.email
            }}</a>
          </p>
          <div class="row" style="display: flex; justify-content: flex-start">
            <span *ngIf="displaySetting?.footer?.facebookHref !== undefined">
              <a
                class="media"
                href="{{ displaySetting?.footer?.facebookHref }}"
                target="_blank"
              >
                <i class="fa fa-facebook-f"></i>
              </a>
            </span>
            <span *ngIf="displaySetting?.footer?.twitterHref !== undefined">
              <a
                class="media"
                href="{{ displaySetting?.footer?.twitterHref }}"
                target="_blank"
              >
                <i class="fa fa-twitter"></i>
              </a>
            </span>
            <span *ngIf="displaySetting?.footer?.instagramHref !== undefined">
              <a
                class="media"
                href="{{ displaySetting?.footer?.instagramHref }}"
                target="_blank"
              >
                <i class="fa fa-instagram"></i>
              </a>
            </span>
            <span *ngIf="displaySetting?.footer?.linkedInHref !== undefined">
              <a
                class="media"
                href="{{ displaySetting?.footer?.linkedInHref }}"
                target="_blank"
              >
                <i class="fa fa-linkedin"></i>
              </a>
            </span>
            <span *ngIf="displaySetting?.footer?.youtubeHref !== undefined">
              <a
                class="media"
                href="{{ displaySetting?.footer?.youtubeHref }}"
                target="_blank"
              >
                <i class="fa fa-youtube" aria-hidden="true"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="promotion-div">
        <div>
          <img
            src="https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/BookMeCheapest/arc.jpg"
            alt=""
          />
        </div>
        <div>
          <p>ARC # 10577092.</p>
          <p>{{ displaySetting?.footer?.copyright }}</p>
        </div>
        <div>
          <img
            src="https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/BookMeCheapest/authnet.gif"
            alt=""
          />
        </div>
        <div>
          <img
            class="stripe-img"
            src="https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/BookMeCheapest/stripe.png"
            alt=""
          />
        </div>
      </div>

      <p class="cid">{{ appContext.searchKey }}</p>
    </footer>
  </div>

  <div
    class="container hmt-footer-main-div"
    *ngIf="appContext.siteName == 'OneStopParking'"
  >
    <div class="main-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">our company</div>
              <div class="context">
                <ul>
                  <li *ngFor="let footer of onStopParkingFooterLinks.company">
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">blog</div>
              <div class="context">
                <ul *ngFor="let footer of onStopParkingFooterLinks.blog">
                  <li>
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">Airport Parking</div>
              <div class="context">
                <ul
                  *ngFor="let footer of onStopParkingFooterLinks.airportParking"
                >
                  <li>
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">Connect with us</div>
              <div class="context">
                <div class="contact">
                  <div class="sub">
                    <div
                      *ngFor="
                        let socialMedia of onStopParkingFooterLinks.socialMedia
                      "
                    >
                      <a
                        *ngIf="socialMedia.link"
                        class="media"
                        href="{{ socialMedia.link }}"
                        target="_blank"
                      >
                        <img
                          style="width: 35px"
                          src="{{ socialMedia.icon }}"
                          alt="Social Media Icon"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="container hmt-footer-main-div"
    *ngIf="appContext.siteName == 'HostMyTrips'"
  >
    <div class="main-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">our company</div>
              <div class="context">
                <ul>
                  <li *ngFor="let footer of hostMyTripsFooterLinks.company">
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">blog</div>
              <div class="context">
                <ul *ngFor="let footer of hostMyTripsFooterLinks.blog">
                  <li>
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">Villas</div>
              <div class="context">
                <ul *ngFor="let footer of hostMyTripsFooterLinks.villas">
                  <li>
                    <a href="{{ footer.link }}" target="_blank">{{
                      footer.text
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-md-6">
        <div class="nav-footer">
          <div class="title">media</div>
          <div class="context">
            <ul *ngFor="let footer of hostMyTripsFooterLinks.media">
              <li>
                <a href="{{ footer.link }}" target="_blank">{{
                  footer.text
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
          <div class="col-lg-3 col-md-6">
            <div class="nav-footer">
              <div class="title">Connect with us</div>
              <div class="context">
                <div class="contact">
                  <div class="sub">
                    <div
                      *ngFor="
                        let socialMedia of hostMyTripsFooterLinks.socialMedia
                      "
                    >
                      <a
                        *ngIf="socialMedia.link"
                        class="media"
                        href="{{ socialMedia.link }}"
                        target="_blank"
                      >
                        <img
                          style="width: 35px"
                          src="{{ socialMedia.icon }}"
                          alt="Social Media Icon"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      'sg-copy-right': appContext.siteName != 'OneStopParking',
      'osp-copy-right': appContext.siteName == 'OneStopParking'
    }"
    *ngIf="
      appContext.siteName == 'HostMyTrips' ||
      appContext.siteName == 'OneStopParking'
    "
  >
    <div>
      <p class="sg-copy">{{ displaySetting?.footer?.copyright }}</p>
      <p
        [ngClass]="{
          'sg-cid': appContext.siteName != 'OneStopParking',
          'osp-cid': appContext.siteName == 'OneStopParking'
        }"
      >
        {{ appContext.searchKey }}
      </p>
    </div>
  </div>
</footer>

<div
  class="rcom-footer-div container-fluid"
  *ngIf="appContext.siteName == 'ReservationsExpert'"
>
  <div class="w-70">
    <div>
      To make a new reservation call
      <a [href]="'tel:' + displaySetting?.phone" class="campaign-phone"
        ><span class="campaign-phone">{{ displaySetting?.phone }}</span></a
      >
    </div>
    <div>
      If you are a person who needs an accessibility accommodation in order to
      utilize this Site and our Services, we offer certain assistance that may
      help. Please call our 24/7 Customer Call Center at
      <a [href]="'tel:' + displaySetting?.phone">{{ displaySetting?.phone }}</a
      >.
    </div>
    <div>
      All Prices are displayed in USD by default, they may be shown in the
      corresponding local currency if you are visiting from one of our supported
      locations outside the USA or if you manually select a different currency.
    </div>
    <div>
      <a href="mytrips" target="_blank"
        >Click here to Cancel your Reservation or Resend Confirmation Email</a
      >
      <!-- . Need additional help?
      <a href="https://support.reservations.com/" target="_blank"
        >Contact Customer Service</a
      > -->
    </div>
    <div>
      ReservationsExpert.com is an Independent Travel Network providing you with
      a vast selection of hotels without any affiliations.
    </div>
  </div>
  <div class="w-30">
    <div>{{ appContext.context?.displaySetting?.footer?.copyright }}</div>
    <div>All rights reserved.</div>
    <div class="links">
      <li>
        <a href="policies/terms-of-service" target="_blank">Terms of Service</a>
      </li>
      &nbsp; | &nbsp;
      <li>
        <a href="policies/privacy-policy" target="_blank">Privacy Policy</a>
      </li>
      &nbsp; | &nbsp;
      <li>
        <a href="policies/cookie-policy" target="_blank">Cookie Policy</a>
      </li>
    </div>
    <p class="res-cid">{{ appContext.searchKey }}</p>
  </div>
</div>
<footer *ngIf="appContext.siteName == 'Sharecare'">
  <div class="container p-5 ">
    <div class="row">
      <div class=" sharecare-nav-footer w-full d-flex flex-row justify-content-between align-items-center">
        <div class="footer-logo">
          <img
        src="{{reckitFooterLogo }} "
        alt="Logo Image"
        class="sharecare-footer-logo"
      />
        </div>
        <div class="context mt-4 ms-5 w-full d-flex flex-row justify-content-end align-items-center gap-4 ">
          <ng-container>
            <li
              class="roboto-semibold "
              style="list-style: none"
              *ngFor="let link of footermenus; let index = index"
            >
              <a
                href="{{ link.href }}"
                target="_blank"

                class="nav-link navanchor sharecare-footermenu  sharecare-footer-link"
                >{{ link.text }}
               </a
              >
            </li>
          </ng-container>
        </div>

      </div>
    </div>
    <p class="sharecare-cid">
         {{ appContext.searchKey }}
        </p>
  </div>
</footer>
